/**
 * ENG-7831: the platform-storage doctrine, single-sourced.
 *
 * One compact policy sentence shared by every identity generator (claude-code
 * CLAUDE.md, opencode AGENTS.md) so the rule cannot drift between adapters.
 * Each generator embeds this string and adds its own framework-specific
 * mechanics around it (the claude-code generator renders a full routing
 * table; the opencode spike keeps a single Operating-rules bullet).
 *
 * Deliberately tool-agnostic: it names artifact kinds, not MCP tool names,
 * so it stays true on adapters whose tool surface differs (the opencode
 * spike may not forward every `mcp__augmented__*` tool).
 */
export const PLATFORM_STORAGE_RULE =
  'Store durable, reusable work you build (repeatable procedures, recurring ' +
  'responsibilities, scheduled automation, orchestration scripts) through the ' +
  'Ninjafy platform tools, never as loose local files, unless the user ' +
  'explicitly requests a different destination. Platform artifacts are ' +
  'versioned, reviewable, and survive re-provisioning; loose local files are ' +
  'wiped on the next provision rebuild, reach no one else, and bypass review. ' +
  'Ephemeral scratch files for the task at hand are fine on disk.';
